import { Link } from 'react-router-dom';
import { styled } from '../styles/stitches.config';


// --- STYLED COMPONENTS ---
export const PageContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  padding: '10rem',
//   backgroundColor: '$gray2',
}); 

export const Title = styled('h1', {
  fontSize: '2rem',
  fontWeight: 600,
  color: '$gray12',
  marginBottom: '0.5rem',
});

// export const Separator = styled('div', {
//   backgroundColor: '$separator',
  
//   // DEFAULT: Horizontal separator (stacked cards)
//   width: '80%',
//   height: '1px',
//   margin: '1rem auto',
//   alignSelf: 'center',
//   flexBasis: '100%', // Forces line break on mobile
// });

export const Separator = styled('div', {
  backgroundColor: '$separator',
  
  // DEFAULT: Vertical separator (side-by-side cards)
  width: '80%',
  height: '1px',
  margin: '1rem auto',
  alignSelf: 'center',

  // WIDE: Vertical (side-by-side)
  '@media (min-width: 950px)': {
    width: '1px',
    height: 'auto',
    margin: '0 1rem',
    alignSelf: 'stretch',
  },

});

export const Subtitle = styled('p', {
  fontSize: '1.1rem',
  color: '$gray11',
  marginBottom: '3rem',
});

export const ChoicesWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  gap: '0.5rem',

  '@media (min-width: 950px)': {
    flexDirection: 'row',
    gap: 0,
  },
});

export const VerticalSeparator = styled('div', {
  width: '1px',
  backgroundColor: '$separator', // Use your theme's separator color
  alignSelf: 'stretch', // This makes it automatically stretch to the height
});

export const HorizontalSeparator = styled('div', {
  height: '1px',
  backgroundColor: '$separator', // Use your theme's separator color
  alignSelf: 'stretch', // This makes it automatically stretch to the height
});



export const ChoiceCard = styled(Link, {
  all: 'unset',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  maxWidth: '25rem',
  padding: '1.5rem',
  backgroundColor: '$subtleBackground',
  border: '1px solid $gray6',
  borderRadius: '16px',
  cursor: 'pointer',
  textAlign: 'center',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',

  '&:hover': {
    transform: 'translateY(-5px)',
    borderColor: 'var(--colors-blue9)',
    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
    '& svg': {
        fill: 'var(--colors-blue11)',
    },
    '& span': {
        color: 'var(--colors-blue11)',
    }
  },

  '@media (min-width: 950px)': {
    height: '18rem',
  },
});

export const CardIcon = styled('div', {
  color: 'var(--colors-blue9)',
  marginBottom: '1.5rem',
});

export const CardTitle = styled('h2', {
  fontSize: '1.5rem',
  fontWeight: 600,
  color: '$gray12',
  margin: 0,
});

export const CardDescription = styled('p', {
  fontSize: '0.9rem',
  color: '$gray11',
  lineHeight: 1.5,
  marginTop: '0.75rem',
});
